export default [
  "ABEV3",
  "AGRO3",
  "ANY",
  "ARZZ3",
  "AZUL4",
  "B3SA3",
  "BBAS3",
  "BBDC4",
  "BBSE3",
  "BEEF3",
  "BGIFUT",
  "BITFUT",
  "BOVA11",
  "BRAP4",
  "BTCUSD",
  "CARD3",
  "CBAV3",
  "CCMFUT",
  "CEAB3",
  "CIEL3",
  "CMIG4",
  "CMIN3",
  "CPFE3",
  "CPLE6",
  "CSNA3",
  "DI1FUT",
  "DMMO3",
  "DOLFUT",
  "EGIE3",
  "ELET3",
  "ELET6",
  "ENAT3",
  "ENGI11",
  "EQTL3",
  "ETHUSD",
  "FESA4",
  "FHER3",
  "FLRY3",
  "GGBR4",
  "GOAU4",
  "GOLL4",
  "HYPE3",
  "ICFFUT",
  "INDFUT",
  "ISPFUT",
  "ITSA4",
  "ITUB4",
  "JBSS3",
  "JHSF3",
  "KEPL3",
  "LOGN3",
  "LPSB3",
  "LREN3",
  "MEAL3",
  "MGLU3",
  "MRVE3",
  "MULT3",
  "ORVR3",
  "PETR3",
  "PETR4",
  "PRIO3",
  "PTBL3",
  "RENT3",
  "SBFG3",
  "SLCE3",
  "SMTO3",
  "SOMA3",
  "SQIA3",
  "STBP3",
  "SUZB3",
  "TAEE11",
  "TRAD3",
  "USIM5",
  "VALE3",
  "VIVA3",
  "VULC3",
  "VVAR3",
  "WDOFUT",
  "WEGE3",
  "WINFUT",
  "WIZS3",
  "WSPFUT",
];
